import React, { useEffect, useRef } from 'react';

import { useLabel } from '@atlas/core';
import { Icon, Label } from '@atlas/ui';

const ErrorField = ({ field }) => {
  const fieldName = useLabel(field.replace('_', ' ')).replaceAll(
    /(\[(?<link>[^\]]+)\]\([^)]+\))/g,
    '$<link>',
  );
  return (
    <li className="signup-error-list-item" key={field}>
      {fieldName}
    </li>
  );
};

const ErrorFields = ({ errorFields }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (errorFields.length > 0) {
      ref.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [errorFields.length, ref]);

  if (errorFields.length === 0) {
    return null;
  }

  return (
    <div className="signup-error-wrapper" ref={ref}>
      <div className="notification-item-icon">
        <Icon className="icon-error" name="error" />
      </div>
      <div className="signup-error-list-wrapper">
        <Label className="signup-error-list-header" message="registration_failed_signup_errors" />
        <ul className="signup-error-list">
          {errorFields.map(field => (
            <ErrorField field={field} key={field} />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ErrorFields;
